
import '@/styles/quasar.scss'
import '@quasar/extras/mdi-v4/mdi-v4.css'
import '@quasar/extras/roboto-font/roboto-font.css'
import iconSet from 'quasar/icon-set/mdi-v7.js'

import { Notify, Dialog, QDialog, QMenu, QStepper, QSelect, QInput, Quasar } from 'quasar'
import { useDetectDevice } from '@/composables/device'
// import { Dialog } from 'quasar'

const { isMobile } = useDetectDevice()

const setDefaults = (elem, opts) => {
  const props = elem.props
  Object.keys(opts).forEach(key => {
    const existingProp = props[key]
    const defaultValue = opts[key]
    const propType = existingProp?.type || (typeof defaultValue === 'boolean' ? Boolean : String)

    props[key] = {
      type: propType,
      default: defaultValue
    }
  })
}

setDefaults(QDialog, {
  transitionShow: isMobile.value ? 'slide-left' : 'scale',
  transitionHide: isMobile.value ? 'slide-right' : 'scale',
})

const POPUP_TRANSITIONS = Object.freeze({ transitionShow: 'jump-down', transitionHide: 'jump-up' })

setDefaults(QMenu, POPUP_TRANSITIONS)

setDefaults(QInput, {
  outlined: true,
  hideBottomSpace: true,
})

setDefaults(QSelect, {
  emitValue: true,
  mapOptions: true,
  outlined: true,
  hideBottomSpace: true,
  behavior: isMobile.value ? 'dialog' : 'menu',
  ...(isMobile.value ? {} : POPUP_TRANSITIONS),
})

setDefaults(QStepper, {
  animated: true,
  flat: true,
  vertical: true,
  headerNav: true,
  color: 'primary',
  doneColor: 'positive',
  inactiveColor: 'grey-5',
  transitionNext: 'slide-left'
})

// Import statici delle lingue supportate per Vite
import langEn from 'quasar/lang/en-US'
import langIt from 'quasar/lang/it'
import langEs from 'quasar/lang/es'
import langDe from 'quasar/lang/de'
import langFr from 'quasar/lang/fr'
import langNl from 'quasar/lang/nl'

const langMap = {
  'en-US': langEn,
  'it-IT': langIt,
  'es-ES': langEs,
  'de-DE': langDe,
  'fr-FR': langFr,
  'nl-NL': langNl
}

export const updateQuasarLocaleAsync = async(localeId) => {
  if (localeId === 'en-US') {
    localeId = 'en-US'
  }

  const lang = langMap[localeId]
  if (lang) {
    Quasar.lang.set(lang)
  } else {
    console.warn(`Language ${localeId} not supported, using en-US as fallback`)
    Quasar.lang.set(langEn)
  }
}

export default {
  config: {
    notify: {
      position: isMobile.value ? 'bottom' : 'top-right',
      timeout: 3000,
      textColor: 'white',
      progress: true
    },
    dialog: {
      transitionShow: 'slide-left',
      transitionHide: 'slide-right'
    }
  },
  plugins: {
    Notify, Dialog
  },
  iconSet: iconSet
}
